<template>
  <section class="education-details-hero topic-1 uk-light">
    <CompanyBreadcrumb :aria-label="$t('general.catalog_trainings')"
                       :home-aria-label="$t('general.home')"
                       :items="breadcrumbItems"
    />

    <div v-if="successMessage"
         class="uk-alert-success bg-success-700 education-details-hero__alert"
         uk-alert
    >
      <a class="uk-alert-close" uk-close></a>
      <p>
        <i aria-hidden="true" class="fa fa-check"></i>
        {{ successMessage }}
      </p>
    </div>

    <span v-if="trainingTypeName" class="education-details-hero__category">
      {{ trainingTypeName }}
    </span>
    <h1>{{ item.name }}</h1>

    <div class="education-details-hero__meta">
      <i aria-hidden="true" class="icon-feather-users"></i>
      <span>
        {{ item.users_completed_count || 0 }}
        {{ $t("education.Person_Completed_Training") }}
      </span>
    </div>
  </section>
</template>

<script>
import CompanyBreadcrumb from "@/view/company/components/breadcrumb/CompanyBreadcrumb.vue";

export default {
  name: "EducationDetailsHero",
  components: {
    CompanyBreadcrumb,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    successMessage: {
      type: String,
      default: null,
    },
  },
  computed: {
    trainingTypeName() {
      return this.item.training_type ? this.item.training_type.name : "";
    },
    breadcrumbItems() {
      return [
        { name: this.$t("general.catalog_trainings") },
        { name: this.trainingTypeName },
        { name: this.item.name || "" },
      ].filter((item) => item.name);
    },
  },
};
</script>

<style scoped>
.education-details-hero {
  min-width: 0;
  min-height: 190px;
  padding: 24px;
  border: 1px solid var(--education-border);
  border-radius: 14px;
  background: #ffffff !important;
}

.education-details-hero__alert {
  min-height: 36px;
  margin: 0 0 16px;
}

.education-details-hero__alert p {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  color: #15803d;
}

.education-details-hero__category {
  display: block;
  margin-bottom: 8px;
  color: var(--education-primary) !important;
  font-size: 14px;
  font-weight: 600;
}

.education-details-hero h1 {
  margin: 0 0 16px;
  color: var(--education-text) !important;
  font-size: 30px;
  font-weight: 700;
  line-height: 1.3;
  overflow-wrap: anywhere;
}

.education-details-hero__meta {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--education-muted);
  font-size: 14px;
  line-height: 1.5;
}

.education-details-hero__meta i {
  flex: 0 0 auto;
  color: var(--education-primary);
  font-size: 18px;
}

@media (max-width: 767px) {
  .education-details-hero {
    min-height: 164px;
    padding: 16px;
  }

  .education-details-hero h1 {
    font-size: 24px;
  }
}
</style>
